import { OnInit, EventEmitter } from '@angular/core';
var MegaMenuBlockComponent = /** @class */ (function () {
    function MegaMenuBlockComponent() {
        this.onItemClick = new EventEmitter();
    }
    MegaMenuBlockComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(MegaMenuBlockComponent.prototype, "menu", {
        get: function () {
            var _this = this;
            if (this.menuItems && this.menuItems.length && this.code) {
                return this.menuItems.find(function (menu) { return menu.code === _this.code; });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MegaMenuBlockComponent.prototype, "hasChildren", {
        get: function () {
            return !!(this.menu.children && this.menu.children.length);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MegaMenuBlockComponent.prototype, "children", {
        get: function () {
            var _this = this;
            return this.menuItems.filter(function (menu) { return menu.parent === _this.menu.code; });
        },
        enumerable: true,
        configurable: true
    });
    MegaMenuBlockComponent.prototype.onClick = function () {
        this.onItemClick.emit();
    };
    return MegaMenuBlockComponent;
}());
export { MegaMenuBlockComponent };
